import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";

import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import UIRadioGroup, { UIRadio } from 'components/custom-ui/UIRadioGroup';
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import React from 'react';
import "./styles.css";
import "./mobile.css";


/**
 * @function DownloadPage
 * @return {React.Component}
 * @exported true
 * @description The main component for DownloadPage
 */
export default function DownloadPage(props) {
    const bcmsContext = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, bcmsContext);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onChange: prop => val => {
          BCMSStateManagerCRUD.init(state)
          .update([ "data", prop ], val === "prop" ? { id: "prop" } : Account.initByType(val))
          .submit(setState);
        }
    });

  return (
    <PageContainer className="download-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  )
}

export const getDefaultPageData = () => ({
  accounts: Account.initAll(),
  selectedAccount: { id: "prompt" },
  startDate: { value: BCMSDate.init().offset([ 0, -2, 0 ]) },
  endDate: { value: BCMSDate.init().offset(-1) },
  selectedDownloadFormat: { value: "Quicken" }
});

export const getDefaultPageUI = () => ({
  accountSelect: { isActive: false },
  startDateSelect: { isActive: false },
  endDateSelect: { isActive: false }
});

function PageContent() {
  const { data, ui, onChange } = useStateManager();
  const accounts = data.accounts;

    // Create all account items for the account dropdown
  const accountItems = accounts.reduce((result, account) => {
    const label = account.balanceLabel;

    let balance = ``;
    let balanceLabel = ``;

    if(account.type === "loan") {
      balance = account.balanceLabel === "Available Balance" ? account.availableBalance.format() : account.currentBalance.format();
    } else if(account.type === "loc") {
      balance = account.availableCredit.format();
      balanceLabel = `(${ account.secondaryBalanceLabel } ${ balance })`;
    } else {
      balance = account.balanceLabel === "Available Balance" ? account.availableBalance.format() : account.currentBalance.format();
      balanceLabel = account.type !== "loan" ? `(${ label } ${ balance })` : "";
    }

    return result.concat(
      <CustomSelectItem value={ account.id } key={ `Download_Account_${ account.id }` } dataPoint={ `Download_Page_Account_Option_${ account.id }` }>
        { `${ account.number } - ${ account.nickname } ${ balanceLabel }` }
      </CustomSelectItem>
    );
  }, [ <CustomSelectItem value="prompt" key="prompt" dataPoint={ `Download_Page_Account_Option_Select` }>-- Select an Account --</CustomSelectItem> ]);

  return (
    <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Download"/>
          <FormContainer className="download-form">
            <FormRowView text="Account">

              <CustomSelect active={ ui.accountSelect.isActive } value={ data.selectedAccount.id }
              dataPoint={ `Account_Select` } onChange={ onChange("selectedAccount") }>
                { accountItems }
              </CustomSelect>

            </FormRowView>
            <FormRowView text="Start Date">
              <DateSelect value={ data.startDate.value } active={ ui.startDateSelect.isActive } 
              enablePast={ true } enableFuture={ false } dataPoint={ `Start_Date_Select` } />
            </FormRowView>
            <FormRowView text="End Date">
              <DateSelect value={ data.endDate.value } dataPoint={ `End_Date_Select` } 
              active={ ui.endDateSelect.isActive } enablePast={ true } enableFuture={ false } />
            </FormRowView>
            <FormRowView text="Download Format">
              <UIRadioGroup value={ data.selectedDownloadFormat.value } >
                <UIRadio label="Quicken" name="download-format" dataPoint={ `Quicken_Radio` } />
                <UIRadio label="Quickbooks" name="download-format" dataPoint={ `Quickbooks_Radio` } />
              </UIRadioGroup>
            </FormRowView>
            <FormRowView>
              <DisabledPrompt>
                <PrimaryButton text="Download" dataPoint={ `Download_Button` } />
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
  );
}
